import React, { useEffect, useState } from 'react';
import Quote from "@system/config/quote";
import { useQuoteStore } from "../../hooks/quote";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import System from 'src/helper/system';
import { DatePicker } from 'rsuite';
import Helper from 'src/helper/Helper';
import ReusableDiv from 'src/helper/ReusableDiv';
import { __remove, __set } from 'src/store/axios_indicator';
import ShowAlert from 'src/component/Global/ShowAlert';

export function QuoteHeaderDetail() {
  const [__check] = useAxiosIndicatorCheck();
  const [{ }, { get_Dowpdown_List, get_Project_Data }, { add_Update_Project_Data }] = useQuoteStore();
  const [dropdownList, setDropdownList] = useState([])
  const [businessType, setBusinessType] = useState([])
  const [industry, setIndustry] = useState([])
  const [projectData, setProjectData] = useState({})
  const [prototypeDate, setPrototypeDate] = useState("")
  const [prodStart, setProdStart] = useState("")
  const [prodEnd, setProdEnd] = useState("")
  const [called, setCalled] = useState(false)
  const [clearPrototypeDate, setClearPrototypeDate] = useState(false)
  const [clearProductionStartDate, setClearProductionStartDate] = useState(false)
  const [clearProductionEndDate, setClearProductionEndDate] = useState(false)

  useEffect(() => {
    async function fetchDropDown() {
      setDropdownList(await get_Dowpdown_List())
    }
    async function fetchProjectData() {
      let data = await get_Project_Data()
      if (data == null) {
        setProjectData({
          projectName: "",
          appplicationInfo: "",
          competition: "",
          quantity: "",
          targetResale: "",
          industry: "",
          businessType: "",
          prototype_date: "",
          productionStart: "",
          productionEnd: ""
        })
        setCalled(true)
      } else {
        setProjectData(data)
        setCalled(true)
        setPrototypeDate(data.prototype_date)
        setProdStart(data.productionStart)
        setProdEnd(data.productionEnd)
      }
    }

    fetchDropDown();
    fetchProjectData();
  }, []);

  useEffect(() => {
    setBusinessType(dropdownList.businessType)
    setIndustry(dropdownList.industry)
  }, [dropdownList])

  const onValueChange = (field, value) => {
    setProjectData({ ...projectData, [field]: value });
  };

  const onSubmit = async (e) => {
    __set('QUOTE_API_CALL');
    const result = await add_Update_Project_Data({ ...projectData, quantity: parseFloat(projectData.quantity), targetResale: parseFloat(projectData.targetResale) });
    if (result.isSuccessFull) {
      window.location.href = Quote.getQuoteAddressRouteURL()
      return;
    }
    __remove('QUOTE_API_CALL');
  }

  return (
    <>
      <div id="main" className="">
        <ShowAlert />
        {ReusableDiv.QuoteHeader(System.getParams().__c)}
        <div id="pcnquote-submit-page" className="pcn-page container">
          <p className='mt-3'>It helps to expedite your quote if we know a little more about your project. This is optional</p>

          <hr className='mb-1 mx-0' />
          <div className="content-box quote-detail-form px-0">
            <h3 className='mt-0 mb-3'>Fill in the project details.</h3>
            <span className="mb-2 d-block"></span>
            <form>
              <div className='bs5 row'>
                <div className='col-9 mb-4'>
                  <div className=" bs5 row">
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="projectName" className='d-block'>Project Name/Reference</label>
                        <input type="text" className="form-control form-control-sm" id="projectName" placeholder="Project Name/Reference"
                          name="projectName"
                          value={projectData?.projectName}
                          onChange={({ target: { value } }) => onValueChange("projectName", value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className=" bs5 row">
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="applicationInfo" className='d-block'>Application Info:</label>
                        <input type="text" className="form-control form-control-sm" id="applicationInfo" placeholder="Application Info"
                          name="appplicationInfo"
                          value={projectData?.appplicationInfo}
                          onChange={({ target: { value } }) => onValueChange("appplicationInfo", value)}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group">
                        <label htmlFor="competition" className='d-block'>Competition</label>
                        <input type="text" className="form-control form-control-sm" id="competition" placeholder="Competition"
                          name="competition"
                          value={projectData?.competition}
                          onChange={({ target: { value } }) => onValueChange("competition", value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="bs5 row">
                    <div className="col-6">
                      <div className="bs5 row">
                        <div className="col-6">
                          <div className="form-group">
                            <label htmlFor="estimatedAnnualUsageQuantity" className='d-block'>Estimated Annual Usage Quantity</label>
                            <input type="number" className="form-control form-control-sm" id="estimatedAnnualUsageQuantity" placeholder="Estimated Annual Usage Quantity"
                              name="quantity"
                              value={projectData?.quantity}
                              onChange={({ target: { value } }) => onValueChange("quantity", value)}
                            />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group">
                            <label htmlFor="targetResale " className='d-block'>Target Cost/Resale</label>
                            <input type="number" className="form-control form-control-sm" id="targetResale" placeholder="Target Cost/Resale"
                              name="targetResale"
                              value={projectData?.targetResale}
                              onChange={({ target: { value } }) => onValueChange("targetResale", value)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="bs5 row">
                        <div className="col-6">
                          <div className="form-group">
                            <label htmlFor="businessType" className='d-block'>Business Type</label>
                            <div className='selectbox'>
                              <select className="form-control form-control-sm" id="quoteReason"
                                name="businessType"
                                value={projectData?.businessType}
                                onChange={({ target: { value } }) => onValueChange("businessType", value)}
                              >
                                <option value="">Choose One</option>
                                {businessType && businessType.map((v, i) => (
                                  <option key={v.refQuoteId} value={v.refQuoteId}>{v.refQuoteName}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group">
                            <label htmlFor="industry" className='d-block'>Industry</label>
                            <div className='selectbox'>
                              <select className="form-control form-control-sm" id="industry"
                                name="industry"
                                value={projectData?.industry}
                                onChange={({ target: { value } }) => onValueChange("industry", value)}
                              >
                                <option value="">Choose One</option>
                                {industry && industry.map((v, i) => (
                                  <option key={v.refQuoteId} value={v.refQuoteId}>{v.refQuoteName}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="bs5 row">
                    <div className="col-6">
                      <div className="bs5 row">
                        <div className="col-6">
                          <div className="form-group" >
                            <label htmlFor="prototypeDate" className='d-block'>Prototype Date</label>
                            {(Helper.valueIsNotNull(prototypeDate)) ?
                              <DatePicker
                                format="MM/dd/yyyy"
                                placeholder="MM/DD/YYYY"
                                editable={false}
                                oneTap
                                name="prototype_date"
                                value={called ? clearPrototypeDate ? "" : new Date(Helper.convertDateFormatToMMDDYYYY(projectData.prototype_date)) : ""}
                                onSelect={(date, event) => {
                                  setClearPrototypeDate(false)
                                  setProjectData({ ...projectData, prototype_date: (Helper.convertDateFormatToMMDDYYYY(date)) })
                                }}
                                onClean={() => {
                                  setClearPrototypeDate(true)
                                  setProjectData({ ...projectData, prototype_date: "" })
                                }}
                              /> :
                              <DatePicker
                                format="MM/dd/yyyy"
                                placeholder="MM/DD/YYYY"
                                editable={false}
                                oneTap
                                name="prototype_date"
                                //value={called?clear?"":Helper.valueIsNotNull(projectData.prototype_date)?new Date(Helper.convertDateFormatToMMDDYYYY(projectData.prototype_date)):"":""}
                                onSelect={(date, event) => {
                                  setClearPrototypeDate(false)
                                  setProjectData({ ...projectData, prototype_date: (Helper.convertDateFormatToMMDDYYYY(date)) })
                                }}
                                onClean={() => {
                                  setClearPrototypeDate(true)
                                  setProjectData({ ...projectData, prototype_date: "" })
                                }}
                              />
                            }
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group" >
                            <label htmlFor="productionStart" className='d-block'>Production Start</label>
                            {(Helper.valueIsNotNull(prodStart)) ?
                              <DatePicker
                                format="MM/dd/yyyy"
                                placeholder="MM/DD/YYYY"
                                editable={false}
                                oneTap
                                name="productionStart"
                                value={called ? clearProductionStartDate ? "" : new Date(Helper.convertDateFormatToMMDDYYYY(projectData.productionStart)) : ""}
                                onSelect={(date, event) => {
                                  setClearProductionStartDate(false)
                                  setProjectData({ ...projectData, productionStart: (Helper.convertDateFormatToMMDDYYYY(date)) })
                                }}
                                onClean={() => {
                                  setClearProductionStartDate(true)
                                  setProjectData({ ...projectData, productionStart: "" })
                                }}
                              /> :
                              <DatePicker
                                format="MM/dd/yyyy"
                                placeholder="MM/DD/YYYY"
                                editable={false}
                                oneTap
                                name="productionStart"
                                //value={called?clear?"":Helper.valueIsNotNull(projectData.prototype_date)?new Date(Helper.convertDateFormatToMMDDYYYY(projectData.prototype_date)):"":""}
                                onSelect={(date, event) => {
                                  setClearProductionStartDate(false)
                                  setProjectData({ ...projectData, productionStart: ((Helper.valueIsNotNull(date)) ? (Helper.convertDateFormatToMMDDYYYY(date)) : "") })
                                }}
                                onClean={() => {
                                  setClearProductionStartDate(true)
                                  setProjectData({ ...projectData, productionStart: "" })
                                }}
                              />
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="bs5 row">
                        <div className="col-6">
                          <div className="form-group" >
                            <label htmlFor="productionEnd" className='d-block'>Production End</label>
                            {(Helper.valueIsNotNull(prodEnd)) ?
                              <DatePicker
                                format="MM/dd/yyyy"
                                placeholder="MM/DD/YYYY"
                                editable={false}
                                oneTap
                                name="productionEnd"
                                value={called ? clearProductionEndDate ? "" : new Date(Helper.convertDateFormatToMMDDYYYY(projectData.productionEnd)) : ""}
                                onSelect={(date, event) => {
                                  setClearProductionEndDate(false)
                                  setProjectData({ ...projectData, productionEnd: (Helper.convertDateFormatToMMDDYYYY(date)) })
                                }}
                                onClean={() => {
                                  setClearProductionEndDate(true)
                                  setProjectData({ ...projectData, productionEnd: "" })
                                }}
                              /> :
                              <DatePicker
                                format="MM/dd/yyyy"
                                placeholder="MM/DD/YYYY"
                                editable={false}
                                oneTap
                                name="productionEnd"
                                //value={called?clear?"":Helper.valueIsNotNull(projectData.prototype_date)?new Date(Helper.convertDateFormatToMMDDYYYY(projectData.prototype_date)):"":""}
                                onSelect={(date, event) => {
                                  setClearProductionEndDate(false)
                                  setProjectData({ ...projectData, productionEnd: (Helper.convertDateFormatToMMDDYYYY(date)) })
                                }}
                                onClean={() => {
                                  setClearProductionEndDate(true)
                                  setProjectData({ ...projectData, productionEnd: "" })
                                }}
                              />
                            }
                          </div>
                        </div>
                        <div className="col-6">

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" bs5 row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="comment" className='d-block'>Comments</label>
                        <textarea className="form-control" rows="5" id="comments" placeholder="End customer information can be entered here. The maximum length of comment is 550 characters."
                          maxLength={550}
                          name="comments"
                          value={projectData?.comments}
                          onChange={({ target: { value } }) => onValueChange("comments", value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div className="pcn-line-divider"></div>
            <div className="d-flex justify-content-between align-items-center">
              <a href={Quote.getQuoteRouteURL()}><i className="fa fa-angle-left" aria-hidden="true"></i> Back to review quote</a>
              <div>
                <a href={Quote.getQuoteAddressRouteURL()}> Skip</a>
                <button disabled={__check('QUOTE_API_CALL').status} className="bs5 btn btn-primary ms-3 w145" data-toggle="modal" data-target="#submit-quote-Modal"
                  onClick={() => onSubmit(projectData)}>
                  {__check('QUOTE_API_CALL').status ? <i className="fa fa-spinner fa-spin" /> : 'CONTINUE'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}